/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The BookFilePayloadItemModel model module.
 * @module model/BookFilePayloadItemModel
 * @version v1.0.0
 */
class BookFilePayloadItemModel {
    /**
     * Constructs a new <code>BookFilePayloadItemModel</code>.
     * @alias module:model/BookFilePayloadItemModel
     */
    constructor() { 
        
        BookFilePayloadItemModel.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>BookFilePayloadItemModel</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/BookFilePayloadItemModel} obj Optional instance to populate.
     * @return {module:model/BookFilePayloadItemModel} The populated <code>BookFilePayloadItemModel</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new BookFilePayloadItemModel();

            if (data.hasOwnProperty('coverId')) {
                obj['coverId'] = ApiClient.convertToType(data['coverId'], 'String');
            }
            if (data.hasOwnProperty('fileId')) {
                obj['fileId'] = ApiClient.convertToType(data['fileId'], 'String');
            }
            if (data.hasOwnProperty('select')) {
                obj['select'] = ApiClient.convertToType(data['select'], 'Boolean');
            }
        }
        return obj;
    }


}

/**
 * @member {String} coverId
 */
BookFilePayloadItemModel.prototype['coverId'] = undefined;

/**
 * @member {String} fileId
 */
BookFilePayloadItemModel.prototype['fileId'] = undefined;

/**
 * @member {Boolean} select
 */
BookFilePayloadItemModel.prototype['select'] = undefined;






export default BookFilePayloadItemModel;

